import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsMessagingAppsRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-messaging-apps',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/messaging-apps',
	exact: true,
};
